import Swiper from 'swiper/bundle';
export default class Carousel {
  constructor(element) {
    this.element = element;
    this.options = {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
        type: 'progressbar',
      },
    };
    this.setOptions();
    this.init();
  }
  init() {
    //console.log('Initialisation de ma composante Carousel');
    new Swiper(this.element, this.options);
  }
  setOptions() {
    if ('split' in this.element.dataset) {
      this.options.breakpoints = {
        768: {
          slidesPerView: 2.5,
        },
      };
      console.log('allo');
    }
    if ('autoplay' in this.element.dataset) {
      this.options.autoplay = {
        delay: 5000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      };
    }
    if ('loop' in this.element.dataset) {
      this.options.loop = true;
    }
    if ('nogap' in this.element.dataset) {
      this.options.spaceBetween = 0;
    }
    if ('slides' in this.element.dataset) {
      this.options.slidesPerView = 1 || this.options.slidesPerView;
      this.options.spaceBetween = 40;
      this.options.breakpoints = {
        375: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2.3,
        },
        1024: {
          slidesPerView: 4,
        },
      };
    }
  }
}
